import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ArrowRight, Loader2, Lock } from "lucide-react";
import { Seo } from "@/components/Seo";
import { useAuth } from "@/context/AuthContext";

const inputCls = "field mt-2";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const meta = document.createElement("meta");
    meta.name = "robots";
    meta.content = "noindex, nofollow";
    document.head.appendChild(meta);
    return () => meta.remove();
  }, []);

  useEffect(() => {
    if (user) navigate(location.state?.from || "/admin", { replace: true });
  }, [user, navigate, location.state]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="flex min-h-[70vh] items-center justify-center bg-cream px-4 py-20">
      <Seo title="Staff Sign In" description="Private area for My Geeks LLC staff." />
      <form data-testid="admin-login-form" onSubmit={submit} className="card w-full max-w-md p-8 md:p-10">
        <p className="eyebrow flex items-center gap-2">
          <Lock size={14} /> Private — Staff Only
        </p>
        <h1 className="mt-3 font-display text-3xl font-bold tracking-tight">Enquiry Inbox</h1>
        <p className="mt-2 text-sm text-slate-600">Sign in to view and manage quote requests.</p>

        <div className="mt-8 space-y-5">
          <div>
            <label htmlFor="admin-email" className="block text-sm font-medium text-ink">Email</label>
            <input data-testid="admin-email-input" id="admin-email" type="email" required autoComplete="username" value={email} onChange={(e) => setEmail(e.target.value)} className={inputCls} />
          </div>
          <div>
            <label htmlFor="admin-password" className="block text-sm font-medium text-ink">Password</label>
            <input data-testid="admin-password-input" id="admin-password" type="password" required autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} className={inputCls} />
          </div>
        </div>

        {error && (
          <p data-testid="admin-login-error" role="alert" className="mt-6 rounded-lg border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700">{error}</p>
        )}

        <button
          type="submit"
          data-testid="admin-login-submit"
          disabled={loading}
          className="btn-primary mt-8 w-full"
        >
          {loading ? "Signing in…" : "Sign In"}
          {loading ? <Loader2 size={16} className="animate-spin" /> : <ArrowRight size={16} />}
        </button>
      </form>
    </div>
  );
}
